import {BaseFormModel} from './base-form-model';

export class UsedCompsSummary extends BaseFormModel<UsedCompsSummary> {
    tabId: number;
    compDate: Date;
    amount: number;
    name: string;
}
